import TailoredGraphBuilder from './tailored-graph-builder';

export default TailoredGraphBuilder;
